var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c(
        "div",
        { class: _vm.$style.header, attrs: { slot: "header" }, slot: "header" },
        [
          _vm.user.profilePicture
            ? _c("img", {
                class: _vm.$style.logo,
                attrs: { src: _vm.logo, alt: "User Image" },
              })
            : _c("div", { class: _vm.$style.logo }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
              ]),
          _c("div", { class: _vm.$style.desc }, [
            _c("div", { class: _vm.$style.name }, [
              _vm._v(" " + _vm._s(_vm.user.fullName) + " "),
            ]),
            _c("div", { class: _vm.$style.role }, [
              _c("i", { staticClass: "material-icons active" }, [
                _vm._v("account_circle"),
              ]),
              _vm._v(" " + _vm._s(_vm.userType && _vm.userType.label) + " "),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          class: _vm.$style.body,
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "div",
            { class: _vm.$style.companies },
            _vm._l(_vm.types, function (type) {
              return _c(
                "div",
                {
                  key: type.value,
                  class: {
                    [_vm.$style.company]: true,
                    [_vm.$style.selected]: _vm.active(type),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.select(type)
                    },
                  },
                },
                [
                  _c("radio", {
                    class: _vm.$style.radio,
                    attrs: { option: type.value, value: _vm.role },
                    on: {
                      input: function ($event) {
                        return _vm.select(type)
                      },
                    },
                  }),
                  _c("div", { class: _vm.$style.name }, [
                    _vm._v(" " + _vm._s(type.label) + " "),
                  ]),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButton mainButton",
              attrs: { disabled: !_vm.canSave },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("account_circle"),
              ]),
              _vm._v(" Apply Changes "),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }